import { Component, ElementRef, EventEmitter, HostListener, OnInit, Output, ViewChild } from '@angular/core';
import { BcbService } from 'src/app/services/bcb/bcb.service';
import { ReferentielService } from 'src/app/services/referentiel/referentiel.service';
import { ReferentielEnum } from 'src/app/utils/enums/referentiel-enum';
import { Cim10 } from 'src/app/utils/interfaces/new/cim10.interface';
import { Filtres } from 'src/app/utils/interfaces/new/filtres.interface';
import { Paginated } from 'src/app/utils/interfaces/new/paginated.interface';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-search-cim10',
  templateUrl: './search-cim10.fragment.html',
  styleUrls: [
    './search-cim10.fragment.scss',
    '../modal.fragment.scss'
  ]
})
export class SearchCim10Fragment implements OnInit {
  @ViewChild('modalBody') public modalBody: ElementRef;
  @ViewChild('outsideModal') public outsideModal: ElementRef;

  @Output() public closeEmitter = new EventEmitter();

  @HostListener('document:mousedown', ['$event'])
  onGlobalClick(event): void {
    if (!environment.closeModalOnClickOutside) {
      return;
    }

    if (!this.modalBody.nativeElement.contains(event.target) && this.outsideModal.nativeElement.contains(event.target)) {
      this.closeSearchCim10();
    }
  }

  public selectedData: any;
  public data: any[] = [];

  public isLoadingCim10: boolean = false;
  public filtre: Filtres = {
    perpage: -1,
    currentPage: 1,
    sortBy: 'id'
  };
  public cim10BodyTable: Paginated<Cim10> = {
    page: 1,
    perpage: 10,
    total: 0,
    objects: []
  };
  public cim10ColumnTable = [
    { title: 'Code', data: 'id' },
    { title: 'Classes', data: 'libelle' }
  ];
  public selectedCodeCim10: Cim10;

  constructor(
    private _bcbService: BcbService,
    private _ref: ReferentielService
  ) { }

  async ngOnInit(): Promise<void> {
    this.isLoadingCim10 = true;
    // await this._ref.findRefListTable(ReferentielEnum.cim10)
    await this._bcbService.getCIM10();
    this.isLoadingCim10 = false;
  }

  public async onSearchCIM10(event: string) {
    this.filtre.currentPage = 1;
    this.filtre.find = event;
    if (event.length >= 3) {
      await this.getSearchResult();
    }
  }

  public async getSearchResult() {
    this.isLoadingCim10 = true;
    this.cim10BodyTable = await this._bcbService.searchCIM10(this.filtre);
    this.cim10BodyTable.total = this.cim10BodyTable.objects.length;
    this.isLoadingCim10 = false;
  }

  public selectedCim10(code: Cim10) {
    this.selectedCodeCim10 = code;
    if (this.selectedData === code) {
      this._doSelectValue({ doSelect: false, valueId: code.id });
      this.selectedData = undefined;
    } else {
      if (this.selectedData) {
        this._doSelectValue({ doSelect: false, valueId: this.selectedData.id });
      }
      this.selectedData = code;
      this._doSelectValue({ doSelect: true, valueId: code.id });
    }
  }

  private _doSelectValue(value: any): void {
    if (this.cim10BodyTable && this.cim10BodyTable.objects) {
      const index = this.cim10BodyTable.objects.findIndex(p => p.id === value.valueId);
      const valueDisplayTable = this.cim10BodyTable.objects.find(p => p.id === value.valueId);

      if (value.doSelect) {
        Object.defineProperty(valueDisplayTable, 'rowColor', { configurable: true, value: 'var(--primary)' });
        Object.defineProperty(valueDisplayTable, 'textColor', { configurable: true, value: 'var(--white)' });
      } else {
        Object.defineProperty(valueDisplayTable, 'rowColor', { configurable: true, value: 'transparent' });
        Object.defineProperty(valueDisplayTable, 'textColor', { configurable: true, value: 'var(--black)' });
      }
      this.cim10BodyTable.objects.splice(index, 1, valueDisplayTable);
    }
  }

  public stopPropagation(event): void {
    event.stopPropagation();
  }

  public closeSearchCim10(cim10?: Cim10): void {
    this.closeEmitter.emit(cim10);
  }
}
